import { useEffect } from "react";

// Loads the Calendly popup widget once and intercepts any click on a
// link pointing to calendly.com, opening it as an on-site popup instead
// of navigating away. Falls back to the normal link if the widget isn't ready.
const CalendlyPopup = () => {
  useEffect(() => {
    if (!document.getElementById("calendly-css")) {
      const link = document.createElement("link");
      link.id = "calendly-css";
      link.rel = "stylesheet";
      link.href = "https://assets.calendly.com/assets/external/widget.css";
      document.head.appendChild(link);
    }
    if (!document.getElementById("calendly-js")) {
      const script = document.createElement("script");
      script.id = "calendly-js";
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }

    const handler = (e) => {
      const anchor = e.target.closest ? e.target.closest('a[href*="calendly.com"]') : null;
      if (!anchor) return;
      if (window.Calendly && typeof window.Calendly.initPopupWidget === "function") {
        e.preventDefault();
        window.Calendly.initPopupWidget({ url: anchor.getAttribute("href") });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return null;
};

export default CalendlyPopup;
